module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/btn_1_pc_e9e306ea1e97486f67a7134abd1c4d30.png";